// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FileList = require("../common/Components/FileList.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/Components/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyPageFiles_property_graphql = require("../../__generated__/PropertyPageFiles_property_graphql.bs.js");

let convertFragment = PropertyPageFiles_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageFiles_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageFiles_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyPageFiles_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageFiles_property_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyPage__Files$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(PropertyPageFiles_property_graphql.node, convertFragment, props.property);
  let files = Stdlib_Array.filterMap(property.files.edges, x => x).map(param => param.node);
  return JsxRuntime.jsx(FileList.make, {
    files: files.map(x => x.fragmentRefs),
    showTitle: props.showTitle
  });
}

let WithoutErrorBoundary = {
  make: PropertyPage__Files$WithoutErrorBoundary
};

function PropertyPage__Files(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "Property files",
    children: JsxRuntime.jsx(PropertyPage__Files$WithoutErrorBoundary, {
      property: props.property,
      showTitle: props.showTitle
    })
  });
}

let make = PropertyPage__Files;

exports.Fragment = Fragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* FileList Not a pure module */
